export const WORKFLOW_GENERATED_USER_MESSAGE = 'WORKFLOW_GENERATED_USER_MESSAGE';